import { Avatar } from '@material-ui/core';
import { Theme, lighten, makeStyles } from '@material-ui/core/styles';
import { CSSProperties } from '@material-ui/styles';
import React, { useMemo } from 'react';

const useStyles = makeStyles((theme: Theme) => {
  const commonCardRating: CSSProperties = {
    height: theme.spacing(3),
    width: theme.spacing(3),
    color: theme.palette.common.white,
  };

  return {
    ratingDefault: {
      ...commonCardRating,
      background: theme.palette.status.aborted,
    },
    ratingA: {
      ...commonCardRating,
      background: theme.palette.status.ok,
    },
    ratingB: {
      ...commonCardRating,
      background: lighten(theme.palette.status.ok, 0.5),
    },
    ratingC: {
      ...commonCardRating,
      background: theme.palette.status.pending,
    },
    ratingD: {
      ...commonCardRating,
      background: theme.palette.status.warning,
    },
    ratingE: {
      ...commonCardRating,
      background: theme.palette.error.main,
    },
  };
});

export const Rating = ({
  rating,
  hideValue,
}: {
  rating?: string;
  hideValue?: boolean;
}) => {
  const classes = useStyles();

  const ratingProp = useMemo(() => {
    switch (rating) {
      case '1.0':
        return {
          name: 'A',
          className: classes.ratingA,
        };

      case '2.0':
        return {
          name: 'B',
          className: classes.ratingB,
        };

      case '3.0':
        return {
          name: 'C',
          className: classes.ratingC,
        };

      case '4.0':
        return {
          name: 'D',
          className: classes.ratingD,
        };

      case '5.0':
        return {
          name: 'E',
          className: classes.ratingE,
        };

      default:
        return {
          name: '',
          className: classes.ratingDefault,
        };
    }
  }, [classes, rating]);

  return (
    <Avatar className={ratingProp.className}>
      {!hideValue && ratingProp.name}
    </Avatar>
  );
};

